import * as React from "react";

import { CheckmarkIcon } from "@impero-com/ui";

import { AssessmentStatus } from "api/generated/model";

import * as theme from "./theme.css";

class AssessmentStatusColumn extends React.PureComponent<AssessmentStatusColumnProps> {
    render = () => {
        const { status } = this.props;
        return (
            <div className={theme.assessmentStatusColumnContainer}>
                <CheckmarkIcon checked={status === "Assessed"} />
            </div>
        );
    };
}

interface AssessmentStatusColumnProps {
    status: AssessmentStatus["type"] | undefined;
}

export { AssessmentStatusColumn, type AssessmentStatusColumnProps };
